/** Swaps the trailing row id of a repeatable field key: `director_name_0` → `director_name_3` */
export const withRepeatId = (fieldKey: string, id: number): string =>
  `${fieldKey.split("_").slice(0, -1).join("_")}_${id}`;
